module.exports = __webpack_public_path__ + "img/20d2f1e.jpg";